// extracted by mini-css-extract-plugin
export default {"tableHeader":"ProductSales_tableHeader__vq5jS"};